<app-dynamic-form [title]="name" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
